(() => {
  const bar = document.getElementById('skull-promo-bar');
  if (!bar || bar.dataset.initialized) return;
  const source = bar.querySelector('[data-skull-promo-bar-config]');
  let config;
  try { config = JSON.parse(source.textContent); } catch (_) { return; }
  bar.dataset.initialized = 'true';
  const root = document.documentElement;
  const spacer = document.querySelector('[data-skull-promo-bar-spacer]');
  const slots = [...bar.querySelectorAll('[data-bar-slot]')];
  const status = bar.querySelector('[data-bar-status]');
  const title = bar.querySelector('[data-bar-title]');
  const timer = bar.querySelector('[data-bar-time]');
  const progress = bar.querySelector('[data-bar-progress]');
  const eligible = new Set(config.eligibleProductIds.map(Number));
  const excludedVariants = new Set([49094703218916, 45998998290660, 49234202001636]);
  const lifecycle = new AbortController();
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const watchedOverlays = new WeakSet();
  const overlaySelector = 'dialog,.pvg-refined-modal,[class^="skull-pvg-modal-"],.header__drawer';
  let cart = window.__SKULL_CART || config.cart;
  let count = 0;
  let heroVisible = false;
  let clockState = null;
  let clockUnsubscribe;
  let resizeFrame = 0;
  let refreshTimer = 0;
  let visibilityFrame = 0;
  let requestController;
  let version = 0;
  let disposed = false;
  let suspended = false;
  let displayed = false;
  let cartSignature = '';

  const text = (key, values = {}) => String(config.copy[key] || '').replace(/__(\w+)__/g, (token, name) => String(values[name.toLowerCase()] ?? token));
  const isGift = item => ['true', '1', true, 1].includes(item.properties?._skull_gift) || ['true', '1', true, 1].includes(item.properties?._skull_auto_gift);
  const eligibleLines = data => (data?.items || []).filter(item => eligible.has(Number(item.product_id)) && !excludedVariants.has(Number(item.variant_id)) && !isGift(item));

  function updateSpace() {
    cancelAnimationFrame(resizeFrame);
    resizeFrame = requestAnimationFrame(() => {
      const height = displayed ? Math.ceil(bar.getBoundingClientRect().height + (parseFloat(getComputedStyle(bar).bottom) || 0)) : 0;
      root.style.setProperty('--skull-promo-bar-height', `${height}px`);
    });
  }

  function setVisible(visible) {
    if (displayed === visible) return;
    displayed = visible;
    bar.hidden = !visible;
    if (spacer) spacer.hidden = !visible;
    document.body.classList.toggle('skull-promo-bar-visible', visible);
    updateSpace();
  }

  function keyboardIsOpen() {
    const active = document.activeElement;
    if (active instanceof Element && active.matches('input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"]),textarea,select,[contenteditable="true"]')) return true;
    return !!window.visualViewport && window.visualViewport.height < window.innerHeight * .72;
  }

  function updateVisibility() {
    visibilityFrame = 0;
    if (disposed) return;
    const unlocked = window.SKULL_SLOT_GATE ? window.SKULL_SLOT_GATE.isUnlocked() : root.dataset.skullPromo !== 'locked';
    const overlay = document.querySelector('dialog[open],.pvg-refined-modal.active,[class^="skull-pvg-modal-"].active,.header__drawer[open]');
    const busy = document.body.classList.contains('skull-hero-visible') || document.body.classList.contains('native-cart-open') || document.body.classList.contains('promo-popup-open');
    const stylesheetReady = getComputedStyle(bar).position === 'fixed';
    setVisible(!!(unlocked && stylesheetReady && clockState && !clockState.expired && !heroVisible && !overlay && !busy && !keyboardIsOpen() && !document.hidden && !suspended));
  }

  function scheduleVisibility() {
    if (!visibilityFrame && !disposed) visibilityFrame = requestAnimationFrame(updateVisibility);
  }

  function watchOverlays(container = document) {
    const nodes = [...(container instanceof Element && container.matches(overlaySelector) ? [container] : []), ...container.querySelectorAll(overlaySelector)];
    for (const node of nodes) {
      if (watchedOverlays.has(node)) continue;
      watchedOverlays.add(node);
      overlayObserver.observe(node, { attributes: true, attributeFilter: ['open', 'class', 'hidden'] });
    }
  }

  function imageUrl(item) {
    const value = item.image || item.featured_image?.url;
    if (!value) return '';
    try {
      const url = new URL(value, location.origin);
      if (!['https:', 'http:'].includes(url.protocol)) return '';
      url.searchParams.set('width', '112');
      return url.href;
    } catch (_) { return ''; }
  }

  function renderCart(data) {
    if (!Array.isArray(data?.items)) return;
    cart = data;
    const lines = eligibleLines(data);
    count = lines.reduce((total, item) => total + Math.max(0, Math.floor(Number(item.quantity) || 0)), 0);
    const base = Math.floor(count / 4) * 4;
    const goal = base + 4;
    const filled = Math.max(0, count - base);
    const offer = `${goal}×${goal / 4}`;
    const signature = JSON.stringify(lines.map(item => [item.key, item.quantity, item.image, item.product_title, item.variant_title]));
    if (signature !== cartSignature) {
      cartSignature = signature;
      title.textContent = text(count === 0 ? 'startTitle' : count < 4 ? 'completeTitle' : 'upgradeTitle', { offer });
      status.textContent = count === 0 ? text('addFirst') : text('addMore', { remaining: goal - count, paid: goal / 4 });
      progress.style.transform = `scaleX(${Math.min(1, filled / 4)})`;
      // Only materialize the four units currently shown, even for large quantities.
      const visibleItems = [];
      let offset = 0;
      for (const item of lines) {
        const quantity = Math.max(0, Math.floor(Number(item.quantity) || 0));
        const start = Math.max(base, offset);
        const end = Math.min(base + 4, offset + quantity);
        for (let position = start; position < end; position++) visibleItems.push(item);
        offset += quantity;
      }
      slots.forEach((slot, index) => {
        const item = visibleItems[index];
        const number = base + index + 1;
        const identity = item ? `${item.key}:${number}:${imageUrl(item)}` : `empty:${number}`;
        slot.toggleAttribute('data-next', !item && index === filled);
        if (slot.dataset.identity === identity) return;
        const changed = !!slot.dataset.identity;
        slot.dataset.identity = identity;
        slot.toggleAttribute('data-filled', !!item);
        const name = item ? [item.product_title || item.title, item.variant_title !== 'Default Title' ? item.variant_title : ''].filter(Boolean).join(' · ') : '';
        if (item) slot.setAttribute('aria-label', text('slotFilled', { number, name }));
        else slot.removeAttribute('aria-label');
        slot.replaceChildren();
        const tile = document.createElement('span');
        tile.className = 'skull-promo-bar__tile';
        const url = item && imageUrl(item);
        const fallback = document.createElement('span');
        fallback.className = 'skull-promo-bar__placeholder';
        fallback.setAttribute('aria-hidden', 'true');
        fallback.textContent = item ? '✓' : '+';
        if (url) {
          const image = new Image(44, 43);
          image.alt = '';
          image.loading = 'lazy';
          image.decoding = 'async';
          image.src = url;
          image.addEventListener('error', () => image.replaceWith(fallback), { once: true });
          tile.append(image);
        } else tile.append(fallback);
        if (item) slot.append(tile);
        else {
          const choice = document.createElement('a');
          choice.className = 'skull-promo-bar__choice';
          choice.dataset.barChoice = '';
          choice.href = `${config.rootUrl}#shop`;
          choice.setAttribute('aria-label', text('chooseSlot', { number }));
          choice.append(tile);
          slot.append(choice);
        }
        if (changed && displayed && item && !reducedMotion.matches) {
          slot.animate([{ opacity: .4, transform: 'translateY(4px) scale(.94)' }, { opacity: 1, transform: 'none' }], { duration: 230, easing: 'ease-out' });
        }
      });
    }
    scheduleVisibility();
  }

  function acceptCart(data) {
    if (!Array.isArray(data?.items)) return;
    version++;
    requestController?.abort();
    requestController = null;
    clearTimeout(refreshTimer);
    renderCart(data);
  }

  async function refreshCart() {
    clearTimeout(refreshTimer);
    if (disposed || suspended || document.hidden) return;
    requestController?.abort();
    const controller = new AbortController();
    requestController = controller;
    const ticket = ++version;
    const timeout = setTimeout(() => controller.abort(), 8000);
    try {
      const response = await fetch(`${config.rootUrl}cart.js`, { credentials: 'same-origin', cache: 'no-store', signal: controller.signal });
      if (!response.ok) return;
      const data = await response.json();
      if (ticket === version && !disposed) renderCart(data);
    } catch (_) {
      // Keep the last confirmed cart. The bar never blocks add or checkout.
    } finally {
      clearTimeout(timeout);
      if (requestController === controller) requestController = null;
    }
  }

  function connectClock() {
    clockUnsubscribe?.();
    clockUnsubscribe = window.SKULL_PROMO_CLOCK?.subscribe(state => {
      clockState = state;
      const seconds = Math.max(0, Math.ceil(state.remainingMs / 1000));
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor(seconds % 3600 / 60);
      timer.textContent = [hours, minutes, seconds % 60].map(value => String(value).padStart(2, '0')).join(':');
      scheduleVisibility();
    });
  }

  const overlayObserver = new MutationObserver(scheduleVisibility);
  const stateObserver = new MutationObserver(scheduleVisibility);
  stateObserver.observe(root, { attributes: true, attributeFilter: ['data-skull-promo'] });
  stateObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  const sectionsObserver = new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) {
      if (node instanceof Element && !bar.contains(node)) watchOverlays(node);
    }
    scheduleVisibility();
  });
  sectionsObserver.observe(document.body, { childList: true });
  const resizeObserver = new ResizeObserver(updateSpace);
  resizeObserver.observe(bar);
  const hero = document.querySelector('#campaign');
  let heroObserver;
  if (hero && 'IntersectionObserver' in window) {
    const rect = hero.getBoundingClientRect();
    heroVisible = rect.bottom > 1 && rect.top < window.innerHeight;
    heroObserver = new IntersectionObserver(entries => {
      heroVisible = entries.some(entry => entry.isIntersecting);
      scheduleVisibility();
    }, { threshold: 0 });
    heroObserver.observe(hero);
  }
  watchOverlays();
  bar.addEventListener('click', event => {
    const choice = event.target instanceof Element && event.target.closest('[data-bar-choice]');
    if (!choice || config.pageType !== 'index' || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const catalog = document.querySelector('#shop,.skull-live-shop');
    if (!catalog) return;
    event.preventDefault();
    catalog.scrollIntoView({ behavior: reducedMotion.matches ? 'instant' : 'smooth', block: 'start' });
  }, { signal: lifecycle.signal });
  document.addEventListener('skull:cart-synced', event => acceptCart(event.detail?.cart), { signal: lifecycle.signal });
  for (const name of ['cart:update', 'cart:updated', 'cart:change', 'cart:refresh']) {
    document.addEventListener(name, event => {
      if (Array.isArray(event.detail?.cart?.items)) acceptCart(event.detail.cart);
      else {
        clearTimeout(refreshTimer);
        refreshTimer = setTimeout(refreshCart, 350);
      }
    }, { signal: lifecycle.signal });
  }
  document.addEventListener('skull:promo-unlocked', scheduleVisibility, { signal: lifecycle.signal });
  document.addEventListener('shopify:section:load', event => { watchOverlays(event.target); scheduleVisibility(); }, { signal: lifecycle.signal });
  document.addEventListener('focusin', scheduleVisibility, { signal: lifecycle.signal });
  document.addEventListener('focusout', scheduleVisibility, { signal: lifecycle.signal });
  document.addEventListener('visibilitychange', () => {
    scheduleVisibility();
    if (!document.hidden) {
      clearTimeout(refreshTimer);
      // The shared cart service normally publishes first; fetch only as a fallback.
      refreshTimer = setTimeout(refreshCart, 700);
    }
  }, { signal: lifecycle.signal });
  window.visualViewport?.addEventListener('resize', scheduleVisibility, { signal: lifecycle.signal });
  window.addEventListener('resize', scheduleVisibility, { signal: lifecycle.signal });
  window.addEventListener('load', scheduleVisibility, { once: true, signal: lifecycle.signal });
  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;
    suspended = false;
    connectClock();
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshCart, 700);
    scheduleVisibility();
  }, { signal: lifecycle.signal });
  window.addEventListener('pagehide', event => {
    suspended = true;
    clockUnsubscribe?.();
    requestController?.abort();
    clearTimeout(refreshTimer);
    cancelAnimationFrame(visibilityFrame);
    cancelAnimationFrame(resizeFrame);
    visibilityFrame = 0;
    resizeFrame = 0;
    if (event.persisted) return;
    disposed = true;
    lifecycle.abort();
    stateObserver.disconnect();
    overlayObserver.disconnect();
    sectionsObserver.disconnect();
    resizeObserver.disconnect();
    heroObserver?.disconnect();
  }, { signal: lifecycle.signal });
  renderCart(cart);
  connectClock();
  updateVisibility();
})();
